export const gdpData = [
  {
    id: 1,
    gdp: 15684750000000,
    country: 'United States'
  },
  {
    id: 2,
    gdp: 8227037000000,
    country: 'China'
  },
  {
    id: 3,
    gdp: 5963969000000,
    country: 'Japan '
  },
  {
    id: 4,
    gdp: 3400579000000,
    country: 'Germany '
  },
  {
    id: 5,
    gdp: 2608699000000,
    country: 'Saint Vincent and the Grenadines'
  },
  {
    id: 6,
    gdp: 2440505000000,
    country: 'United Kingdom'
  },
  {
    id: 7,
    gdp: 2395968000000,
    country: 'Brazil '
  },
  {
    id: 8,
    gdp: 2021960000000,
    country: 'Russia'
  },
  {
    id: 9,
    gdp: 2014079000000,
    country: 'Italy'
  },
  {
    id: 10,
    gdp: 1824832000000,
    country: 'India'
  },
  {
    id: 11,
    gdp: 1819081000000,
    country: 'Canada'
  },
  {
    id: 12,
    gdp: 1541797000000,
    country: 'Australia'
  },
  {
    id: 13,
    gdp: 1352057000000,
    country: 'Spain'
  },
  {
    id: 14,
    gdp: 1177116000000,
    country: 'Mexico'
  },
  {
    id: 15,
    gdp: 1155872000000,
    country: 'South Korea'
  },
  {
    id: 16,
    gdp: 878198000000,
    country: 'Indonesia'
  },
  {
    id: 17,
    gdp: 794468000000,
    country: 'Turkey'
  },
  {
    id: 18,
    gdp: 773116000000,
    country: 'Netherlands'
  },
  {
    id: 19,
    gdp: 727307000000,
    country: 'Saudi Arabia'
  },
  {
    id: 20,
    gdp: 632400000000,
    country: 'Switzerland'
  },
  {
    id: 21,
    gdp: 548895000000,
    country: 'Iran'
  },
  {
    id: 22,
    gdp: 526192000000,
    country: 'Sweden'
  },
  {
    id: 23,
    gdp: 501101000000,
    country: 'Norway'
  },
  {
    id: 24,
    gdp: 487674000000,
    country: 'Poland'
  },
  {
    id: 25,
    gdp: 484692000000,
    country: 'Belgium'
  },
  {
    id: 26,
    gdp: 474954000000,
    country: 'Argentina'
  },
  {
    id: 27,
    gdp: 473971000000,
    country: 'Taiwan'
  },
  {
    id: 28,
    gdp: 398594000000,
    country: 'Austria'
  },
  {
    id: 29,
    gdp: 384315000000,
    country: 'South Africa'
  },
  {
    id: 30,
    gdp: 382424000000,
    country: 'Venezuela'
  },
  {
    id: 31,
    gdp: 366020000000,
    country: 'Colombia'
  },
  {
    id: 32,
    gdp: 365564000000,
    country: 'Thailand'
  },
  {
    id: 33,
    gdp: 358940000000,
    country: 'United Arab Emirates'
  },
  {
    id: 34,
    gdp: 313637000000,
    country: 'Denmark'
  },
  {
    id: 35,
    gdp: 303527000000,
    country: 'Malaysia'
  },
  {
    id: 36,
    gdp: 276520000000,
    country: 'Singapore'
  },
  {
    id: 37,
    gdp: 268708000000,
    country: 'Nigeria'
  },
  {
    id: 38,
    gdp: 268177000000,
    country: 'Chile'
  },
  {
    id: 39,
    gdp: 263021000000,
    country: 'Hong Kong'
  },
  {
    id: 40,
    gdp: 256729000000,
    country: 'Egypt'
  },
  {
    id: 41,
    gdp: 250436000000,
    country: 'Philippines'
  },
  {
    id: 42,
    gdp: 250126000000,
    country: 'Finland'
  },
  {
    id: 43,
    gdp: 249201000000,
    country: 'Greece'
  },
  {
    id: 44,
    gdp: 240894000000,
    country: 'Israel'
  },
  {
    id: 45,
    gdp: 231879000000,
    country: 'Pakistan'
  },
  {
    id: 46,
    gdp: 212720000000,
    country: 'Portugal'
  },
  {
    id: 47,
    gdp: 212501000000,
    country: 'Iraq'
  },
  {
    id: 48,
    gdp: 210416000000,
    country: 'Ireland'
  },
  {
    id: 49,
    gdp: 207794000000,
    country: 'Algeria'
  },
  {
    id: 50,
    gdp: 199003000000,
    country: 'Paraguay'
  },
  {
    id: 51,
    gdp: 199003000000,
    country: 'Peru'
  },
  {
    id: 52,
    gdp: 196419000000,
    country: 'Kazakhstan'
  },
  {
    id: 53,
    gdp: 196072000000,
    country: 'Czech Republic'
  },
  {
    id: 54,
    gdp: 183378000000,
    country: 'Qatar'
  },
  {
    id: 55,
    gdp: 176235000000,
    country: 'Ukraine'
  },
  {
    id: 56,
    gdp: 173424000000,
    country: 'Kuwait'
  },
  {
    id: 57,
    gdp: 169680000000,
    country: 'New Zealand'
  },
  {
    id: 58,
    gdp: 169680000000,
    country: 'Romania'
  },
  {
    id: 59,
    gdp: 138071000000,
    country: 'Vietnam'
  },
  {
    id: 60,
    gdp: 126873000000,
    country: 'Hungary'
  },
  {
    id: 61,
    gdp: 122724000000,
    country: 'Bangladesh'
  },
  {
    id: 62,
    gdp: 118719000000,
    country: 'Angola'
  },
  {
    id: 63,
    gdp: 97530000000,
    country: 'Morocco'
  },
  {
    id: 64,
    gdp: 91916000000,
    country: 'Slovakia'
  },
  {
    id: 65,
    gdp: 81915000000,
    country: 'Libya'
  },
  {
    id: 66,
    gdp: 80927000000,
    country: 'Ecuador'
  },
  {
    id: 67,
    gdp: 76464000000,
    country: 'Oman'
  },
  {
    id: 68,
    gdp: 68804000000,
    country: 'Azerbaijan'
  },
  {
    id: 69,
    gdp: 63259000000,
    country: 'Belarus'
  },
  {
    id: 70,
    gdp: 59941000000,
    country: 'Sudan'
  },
  {
    id: 71,
    gdp: 59408000000,
    country: 'Sri Lanka'
  },
  {
    id: 72,
    gdp: 58996000000,
    country: 'Dominican Republic'
  },
  {
    id: 73,
    gdp: 57102000000,
    country: 'Croatia'
  },
  {
    id: 74,
    gdp: 56738000000,
    country: 'Luxembourg'
  },
  {
    id: 75,
    gdp: 53140000000,
    country: 'Burma'
  },
  {
    id: 76,
    gdp: 51168000000,
    country: 'Uzbekistan'
  },
  {
    id: 77,
    gdp: 51020000000,
    country: 'Bulgaria'
  },
  {
    id: 78,
    gdp: 49880000000,
    country: 'Guatemala'
  },
  {
    id: 79,
    gdp: 49404000000,
    country: 'Uruguay'
  },
  {
    id: 80,
    gdp: 45617000000,
    country: 'Slovenia'
  },
  {
    id: 81,
    gdp: 45611000000,
    country: 'Tunisia'
  },
  {
    id: 82,
    gdp: 45134000000,
    country: 'Costa Rica'
  },
  {
    id: 83,
    gdp: 42164000000,
    country: 'Lithuania'
  },
  {
    id: 84,
    gdp: 41906000000,
    country: 'Ethiopia'
  },
  {
    id: 85,
    gdp: 41345000000,
    country: 'Lebanon'
  },
  {
    id: 86,
    gdp: 41117000000,
    country: 'Kenya'
  },
  {
    id: 87,
    gdp: 38939000000,
    country: 'Ghana'
  },
  {
    id: 88,
    gdp: 37399000000,
    country: 'Serbia'
  },
  {
    id: 89,
    gdp: 36253000000,
    country: 'Panama'
  },
  {
    id: 90,
    gdp: 35641000000,
    country: 'Yemen'
  },
  {
    id: 91,
    gdp: 33679000000,
    country: 'Turkmenistan'
  },
  {
    id: 92,
    gdp: 31209000000,
    country: 'Jordan'
  },
  {
    id: 93,
    gdp: 28380000000,
    country: 'Latvia'
  },
  {
    id: 94,
    gdp: 28247000000,
    country: 'Tanzania'
  },
  {
    id: 95,
    gdp: 27429000000,
    country: 'Bolivia'
  },
  {
    id: 96,
    gdp: 27026000000,
    country: 'Bahrain'
  },
  {
    id: 97,
    gdp: 25277000000,
    country: 'Trinidad and Tobago'
  },
  {
    id: 98,
    gdp: 25005000000,
    country: 'Cameroon'
  },
  {
    id: 99,
    gdp: 24627000000,
    country: "Cote d'Ivoire"
  },
  {
    id: 100,
    gdp: 23816000000,
    country: 'El Salvador'
  },
  {
    id: 101,
    gdp: 23006000000,
    country: 'Cyprus'
  },
  {
    id: 102,
    gdp: 21863000000,
    country: 'Estonia'
  },
  {
    id: 103,
    gdp: 21002000000,
    country: 'Uganda'
  },
  {
    id: 104,
    gdp: 20517000000,
    country: 'Zambia'
  },
  {
    id: 105,
    gdp: 19906000000,
    country: 'Afghanistan'
  },
  {
    id: 106,
    gdp: 19415000000,
    country: 'Nepal'
  },
  {
    id: 107,
    gdp: 18388000000,
    country: 'Honduras'
  },
  {
    id: 108,
    gdp: 18376000000,
    country: 'Gabon'
  },
  {
    id: 109,
    gdp: 17703000000,
    country: 'Congo, Democratic Republic of the'
  },
  {
    id: 110,
    gdp: 17624000000,
    country: 'Botswana'
  },
  {
    id: 111,
    gdp: 17326000000,
    country: 'Bosnia and Herzegovina'
  },
  {
    id: 112,
    gdp: 17206000000,
    country: 'Equatorial Guinea'
  },
  {
    id: 113,
    gdp: 16628000000,
    country: 'Brunei'
  },
  {
    id: 114,
    gdp: 15934000000,
    country: 'Georgia'
  },
  {
    id: 115,
    gdp: 15786000000,
    country: 'Papua New Guinea'
  },
  {
    id: 116,
    gdp: 15249000000,
    country: 'Jamaica'
  },
  {
    id: 117,
    gdp: 14600000000,
    country: 'Mozambique'
  },
  {
    id: 118,
    gdp: 14241000000,
    country: 'Cambodia'
  },
  {
    id: 119,
    gdp: 13864000000,
    country: 'Senegal'
  },
  {
    id: 120,
    gdp: 13692000000,
    country: 'Congo, Republic of the'
  },
  {
    id: 121,
    gdp: 13654000000,
    country: 'Iceland'
  },
  {
    id: 122,
    gdp: 12688000000,
    country: 'Albania'
  },
  {
    id: 123,
    gdp: 12299000000,
    country: 'Namibia'
  },
  {
    id: 124,
    gdp: 12202000000,
    country: 'South Sudan'
  },
  {
    id: 125,
    gdp: 11466000000,
    country: 'Mauritius'
  },
  {
    id: 126,
    gdp: 10806000000,
    country: 'Chad'
  },
  {
    id: 127,
    gdp: 10646000000,
    country: 'Burkina Faso'
  },
  {
    id: 128,
    gdp: 10506000000,
    country: 'Nicaragua'
  },
  {
    id: 129,
    gdp: 10319000000,
    country: 'Mali'
  },
  {
    id: 130,
    gdp: 10258000000,
    country: 'Mongolia'
  },
  {
    id: 131,
    gdp: 10117000000,
    country: 'Madagascar'
  },
  {
    id: 132,
    gdp: 10066000000,
    country: 'Armenia'
  },
  {
    id: 133,
    gdp: 9802000000,
    country: 'Zimbabwe'
  },
  {
    id: 134,
    gdp: 9676000000,
    country: 'Macedonia, Republic of'
  },
  {
    id: 135,
    gdp: 9217000000,
    country: 'Laos'
  },
  {
    id: 136,
    gdp: 8689000000,
    country: 'Malta'
  },
  {
    id: 137,
    gdp: 8043000000,
    country: 'Bahamas, The'
  },
  {
    id: 138,
    gdp: 7902000000,
    country: 'Haiti'
  },
  {
    id: 139,
    gdp: 7592000000,
    country: 'Tajikistan'
  },
  {
    id: 140,
    gdp: 7429000000,
    country: 'Benin'
  },
  {
    id: 141,
    gdp: 7252000000,
    country: 'Moldova'
  },
  {
    id: 142,
    gdp: 7223000000,
    country: 'Rwanda'
  },
  {
    id: 143,
    gdp: 6575000000,
    country: 'Niger'
  },
  {
    id: 144,
    gdp: 6473000000,
    country: 'Kyrgyzstan'
  },
  {
    id: 145,
    gdp: 5632000000,
    country: 'Guinea'
  },
  {
    id: 146,
    gdp: 4738000000,
    country: 'Suriname'
  },
  {
    id: 147,
    gdp: 4490000000,
    country: 'Barbados'
  },
  {
    id: 148,
    gdp: 4280000000,
    country: 'Montenegro'
  },
  {
    id: 149,
    gdp: 4212000000,
    country: 'Malawi'
  },
  {
    id: 150,
    gdp: 4199000000,
    country: 'Mauritania'
  },
  {
    id: 151,
    gdp: 4173000000,
    country: 'Timor-Leste'
  },
  {
    id: 152,
    gdp: 3996000000,
    country: 'Fiji'
  },
  {
    id: 153,
    gdp: 3777000000,
    country: 'Sierra Leone'
  },
  {
    id: 154,
    gdp: 3751000000,
    country: 'Swaziland'
  },
  {
    id: 155,
    gdp: 3685000000,
    country: 'Togo'
  },
  {
    id: 156,
    gdp: 3092000000,
    country: 'Eritrea'
  },
  {
    id: 157,
    gdp: 2788000000,
    country: 'Guyana'
  },
  {
    id: 158,
    gdp: 2475000000,
    country: 'Burundi'
  },
  {
    id: 159,
    gdp: 2439000000,
    country: 'Lesotho'
  },
  {
    id: 160,
    gdp: 2209000000,
    country: 'Maldives'
  },
  {
    id: 161,
    gdp: 2196000000,
    country: 'Bhutan'
  },
  {
    id: 162,
    gdp: 2172000000,
    country: 'Central African Republic'
  },
  {
    id: 163,
    gdp: 1899000000,
    country: 'Cape Verde'
  },
  {
    id: 164,
    gdp: 1855000000,
    country: 'San Marino'
  },
  {
    id: 165,
    gdp: 1735000000,
    country: 'Liberia'
  },
  {
    id: 166,
    gdp: 1554000000,
    country: 'Belize'
  },
  {
    id: 167,
    gdp: 1354000000,
    country: 'Djibouti'
  },
  {
    id: 168,
    gdp: 1220000000,
    country: 'Saint Lucia'
  },
  {
    id: 169,
    gdp: 1176000000,
    country: 'Antigua and Barbuda'
  },
  {
    id: 170,
    gdp: 1031000000,
    country: 'Seychelles'
  },
  {
    id: 171,
    gdp: 1010000000,
    country: 'Solomon Islands'
  },
  {
    id: 172,
    gdp: 918000000,
    country: 'Gambia, The'
  },
  {
    id: 173,
    gdp: 870000000,
    country: 'Guinea-Bissau'
  },
  {
    id: 174,
    gdp: 790000000,
    country: 'Grenada'
  },
  {
    id: 175,
    gdp: 783000000,
    country: 'Vanuatu'
  },
  {
    id: 176,
    gdp: 734000000,
    country: 'Saint Kitts and Nevis'
  },
  {
    id: 177,
    gdp: 712000000,
    country: 'France'
  },
  {
    id: 178,
    gdp: 683000000,
    country: 'Samoa'
  },
  {
    id: 179,
    gdp: 600000000,
    country: 'Comoros'
  },
  {
    id: 180,
    gdp: 497000000,
    country: 'Dominica'
  },
  {
    id: 181,
    gdp: 476000000,
    country: 'Tonga'
  },
  {
    id: 182,
    gdp: 264000000,
    country: 'Sao Tome and Principe'
  },
  {
    id: 183,
    gdp: 173000000,
    country: 'Kiribati'
  },
  {
    id: 0,
    gdp: 37000000,
    country: 'Tuvalu'
  }
];
